export default "__VITE_ASSET__DmhHAUtT__"